import { useCallback, useMemo, useState } from "react";
import { useErrorSuccess } from "../../../hooks/useErrorSuccess";
import api from "../../../utils/api";

type dashPgItem = {
  bairrocelula: string,
  celula: string
  diasemana: string
  email: string
  estado: string
  estadocivil: string
  genero: 'Masculino' | 'Feminino'
  inscricao: string
  media: string
  nome: string
  nomecargo: string
  nomecelula: string
  nomesede: string
  nometipo: string
  sede: number
  telefone: string
  tipopg: number
  usuario: number
}

interface ServicesDashboard {
  params?: any
}

interface ResServicesDashboardProps {
  pessoasPorSede: any[];
  pessoasPorIdade: any[];
  pessoasPorGenero: any[];
  pessoasPorEstadoCivil: any[];
  estadosCadastrados: any[];
  todosRegistros: any[];
  tipoDePg: any[];
  totalDeCelulas: any[]
  getPessoasPorMinisterioSede: (idsede: number) => any[];
}

export const ServicesDashboard = ({ params }: ServicesDashboard): ResServicesDashboardProps => {

  const { setErrorSuccess } = useErrorSuccess()

  const [dados, setDados] = useState<dashPgItem[]>([]);

  const getDados = useCallback(async () => {
    if(params) {

    } else {
      try {
        const req = await api.get('view/dash/crm');
        const res = await req.data;
        setDados(res);
      } catch (error) {
        setErrorSuccess({
          mensagem: JSON.stringify(error?.response?.data, null, 2),
          status: 'error'
        });
      }
    }
  }, [params])

  const pessoasPorGenero = dados?.reduce(
    (prev, current) => {
    const temNoIndex = prev?.findIndex((pessoa) => pessoa?.genero == current?.genero);
    if(temNoIndex > -1) {

      prev[temNoIndex].quantidade += 1;
      return prev
    }
    /*@ts-ignore*/

    return prev?.concat({ genero: current?.genero, quantidade: 1 })
  } , [])

  const pessoasPorIdade = dados?.reduce((prev, current) => {
    const temNoIndex = prev?.findIndex((pessoa) => pessoa?.media == current?.media);
    if(temNoIndex > -1) {

      prev[temNoIndex].quantidade += 1
      return prev
    }

    return prev?.concat({ media: current?.media, quantidade: 1 })
  } , [])

  const estadosCadastrados = dados?.reduce((prev, current) => {
    const temNoIndex = prev?.findIndex((pessoa) => pessoa?.estado == current?.estado);
    if(temNoIndex > -1) {

      prev[temNoIndex].quantidade += 1
      return prev
    }
    console.log(current?.estado)
    return prev?.concat({ estado: current?.estado, quantidade: 1 })
  } , [])

  const totalDeCelulas = dados?.reduce((prev, current) => {
    const temNoIndex = prev?.findIndex((pessoa) => pessoa?.celula == current?.celula);
    if(temNoIndex > -1) {

      prev[temNoIndex].quantidade += 1
      return prev
    }

    return prev?.concat({ celula: current?.celula, quantidade: 1 })
  } , [])

  const pessoasPorSede = dados?.reduce((prev, current) => {
    const temNoIndex = prev?.findIndex((pessoa) => pessoa?.sede == current?.sede);
    if(temNoIndex > -1) {
      prev[temNoIndex].quantidade += 1
      return prev
    }
    /*@ts-ignore*/
    return prev?.concat({ sede: current?.sede, nomesede: String(current?.nomesede).replace('null', 'Sem PG'), quantidade: 1 })
  } , [])

  const pessoasPorEstadoCivil = dados?.reduce((prev, current) => {
    const temNoIndex = prev?.findIndex((pessoa) => pessoa?.estadocivil == current?.estadocivil);
    if(temNoIndex > -1) {

      prev[temNoIndex].quantidade += 1;
      return prev
    }
    /*@ts-ignore*/
    return prev?.concat({ estadocivil: current?.estadocivil, quantidade: 1 });
  } , [])

  const tipoDePg = dados?.reduce((prev, current) => {
    const temNoIndex = prev?.findIndex((pessoa) => pessoa?.tipopg == current?.tipopg);
    if(temNoIndex > -1) {

      prev[temNoIndex].quantidade += 1;
      return prev
    }
    /*@ts-ignore*/
    return prev?.concat({ tipopg: current?.tipopg, quantidade: 1 });
  } , [])

  const getPessoasPorMinisterioSede = (idsede: number) => dados?.filter(el => el?.sede == idsede).reduce((prev, current) => {
    const temNoIndex = prev?.findIndex((pessoa) => pessoa?.tipopg == current?.tipopg);
    if(temNoIndex > -1) {

      prev[temNoIndex].quantidade += 1;
      return prev
    }
    /*@ts-ignore*/

    return prev?.concat({ tipopg: current?.tipopg, nometipo: current?.nometipo, quantidade: 1 })
  } , [])

  useMemo(() => {
    getDados()
  }, [params])


  return {
    tipoDePg,
    estadosCadastrados,
    totalDeCelulas,
    getPessoasPorMinisterioSede,
    pessoasPorEstadoCivil,
    pessoasPorGenero,
    pessoasPorIdade,
    pessoasPorSede,
    todosRegistros: dados
  };
};

